import {
  Button,
  DrawerBody,
  DrawerFooter,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftAddon,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useCreateResellerModalContext } from '../ModalContext';

const formatPrice = (value: number): string =>
  value.toFixed(2).replace('.', ',');

const parsePrice = (value: string): number => {
  const normalized = value
    .replace(/\./g, '')
    .replace(',', '.')
    .replace(/[^0-9.]/g, '');
  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const ServiceStep: React.FC = () => {
  const { servicePrice, setServicePrice, previousStep, handleSubmit, loading } =
    useCreateResellerModalContext();

  const [priceText, setPriceText] = useState(formatPrice(servicePrice));

  const invalidPrice = !servicePrice || servicePrice <= 0;

  return (
    <>
      <DrawerBody>
        <Flex columnGap="5%" rowGap="1rem" wrap="wrap">
          <FormControl flexBasis="100%" isReadOnly>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Serviço
            </FormLabel>
            <Input value="Plano Revendedor" bg="gray.50" />
          </FormControl>

          <FormControl flexBasis="47.5%" isRequired isInvalid={invalidPrice}>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Valor do serviço
            </FormLabel>
            <InputGroup>
              <InputLeftAddon>R$</InputLeftAddon>
              <Input
                inputMode="decimal"
                value={priceText}
                onChange={(e) => {
                  const raw = e.target.value.replace(/[^\d.,]/g, '');
                  setPriceText(raw);
                  setServicePrice(parsePrice(raw));
                }}
                onBlur={() => setPriceText(formatPrice(servicePrice))}
              />
            </InputGroup>
            {invalidPrice && (
              <FormErrorMessage>Informe um valor válido</FormErrorMessage>
            )}
          </FormControl>
        </Flex>
      </DrawerBody>

      <DrawerFooter gap="1rem">
        <Button variant="outline" onClick={previousStep} flex="1">
          Voltar
        </Button>
        <Button
          colorScheme="yooga"
          onClick={handleSubmit}
          flex="1"
          isDisabled={loading || invalidPrice}
        >
          Salvar
        </Button>
      </DrawerFooter>
    </>
  );
};

export default ServiceStep;
